import React, { ReactNode } from "react";
import styled from "styled-components";
import { ScrollRestoration } from "react-router-dom";

const ComponentBox = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	margin-top: auto;
	width: 100%;
	height: 100%;
	overflow-x: auto;
`;

function MainLayout({ children }: { children: ReactNode }) {
	return (
		<div data-test-id="main-layout">
			<ComponentBox>{children}</ComponentBox>
			<ScrollRestoration />
		</div>
	);
}

export default MainLayout;
